import * as types from "../actions/employeeTypes.js";

const initialState = {
    employeeTypes: [],
    loading: false,
    error: null,
};

const employeeTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_EMPLOYEE_TYPES_REQUEST:
            return { 
                ...state,
                loading: true,
                error: null 
            };

        case types.FETCH_EMPLOYEE_TYPES_SUCCESS:
            return { 
                ...state, 
                loading: false,
                employeeTypes: action.payload 
            };

        case types.FETCH_EMPLOYEE_TYPES_FAILURE:
            return { 
                ...state, 
                loading: false,
                error: action.payload 
            };

        default:
            return state;
    }
};

export default employeeTypesReducer;